import { useState } from 'react';
import { useChatStore } from '@/store/chatStore';
import { Config } from '@/types';

export default function ConfigPanel() {
  const config = useChatStore((state) => state.config);
  const setConfig = useChatStore((state) => state.setConfig);
  
  const [localConfig, setLocalConfig] = useState<Config>(config);

  const handleChange = (path: string, value: any) => {
    setLocalConfig((prev) => {
      const newConfig = { ...prev };
      const keys = path.split('.');
      let current: any = newConfig;
      
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      
      return newConfig;
    });
  };

  const handleSave = () => {
    setConfig(localConfig);
  };

  return (
    <div className="config-panel">
      <h2>Configuration</h2>
      
      <div className="config-section">
        <h3>LLM Settings</h3>
        
        <div className="config-field">
          <label>Provider:</label>
          <input
            type="text"
            value={localConfig.llm.provider}
            onChange={(e) => handleChange('llm.provider', e.target.value)}
          />
        </div>
        
        <div className="config-field">
          <label>Model:</label>
          <input
            type="text"
            value={localConfig.llm.model}
            onChange={(e) => handleChange('llm.model', e.target.value)}
          />
        </div>
        
        <div className="config-field">
          <label>Temperature:</label>
          <input
            type="number"
            value={localConfig.llm.temperature}
            onChange={(e) => handleChange('llm.temperature', parseFloat(e.target.value))}
            step="0.1"
            min="0"
            max="2"
          />
        </div>
        
        <div className="config-field">
          <label>Max Tokens:</label>
          <input
            type="number"
            value={localConfig.llm.maxTokens}
            onChange={(e) => handleChange('llm.maxTokens', parseInt(e.target.value))}
            min="1"
          />
        </div>
      </div>

      <div className="config-section">
        <h3>Tools Configuration</h3>
        
        <div className="config-field">
          <label>
            <input
              type="checkbox"
              checked={localConfig.tools.enabled}
              onChange={(e) => handleChange('tools.enabled', e.target.checked)}
            />
            Enable Tools
          </label>
        </div>
        
        <div className="config-field">
          <label>MCP Servers:</label>
          <ul>
            {localConfig.tools.mcpServers.map((server, index) => (
              <li key={index}>{server}</li>
            ))}
          </ul>
        </div>
      </div>

      <button onClick={handleSave} className="save-button">
        Save Configuration
      </button>
    </div>
  );
}
